import React from 'react';

import {isProductSearchHitModel} from 'coreClasses/search/ProductSearchHitModel';

import ProductDescription from 'brandComponents/ProductDescription';
import {useProductHitContext} from 'brandComponents/ProductHit';

// eslint-disable-next-line no-restricted-imports
import './ProductHitDescription.scss';

const ProductHitDescription = ({hideReadMore}) => {
	const {product} = useProductHitContext();

	const text = !isProductSearchHitModel(product)
		? product?.getShortDescription()
		: undefined;

	if (!text) {
		return null;
	}

	return <ProductDescription
		classNames="product-hit__description"
		hideReadMore={hideReadMore}
		text={text}
	/>;
};

export default ProductHitDescription;
